import { SelectionType as l } from "../reducer/businessModal.types.js";
const I = (s, e) => {
  const {
    selectedBusinessIds: r = [],
    unselectedBusinessIds: n = [],
    selection: o
  } = e ?? {}, c = o?.searchCity ?? "", i = o?.searchOrg ?? void 0, t = o?.searchBusiness ?? "", u = o?.groupIds ?? [], d = o?.type === l.ALL_WITH_FILTERS ? u.join(",") : "";
  return {
    ...s,
    business__in: r.join(","),
    business__notin: n.join(","),
    city: c,
    org_id: i,
    query: t,
    groups: d
  };
}, a = (s) => s ? s.split(",") : [], B = (s = [], e) => {
  const n = ["query", "city", "org_id"].filter((o) => e?.[o] === !1);
  return Array.from(/* @__PURE__ */ new Set([...s, ...n]));
}, p = (s, e = []) => {
  const {
    groupIds: r,
    searchBusiness: n,
    searchCity: o,
    searchOrg: c
  } = s, i = !e.includes("groups") && Array.isArray(r) && r.length > 0, t = !e.includes("query") && !!n, u = !e.includes("city") && !!o, d = !e.includes("org_id") && !!c;
  return i || t || u || d;
}, h = (s, e, r) => p(s, r) || e?.length ? l.ALL_WITH_FILTERS : l.UNSET, F = (s, e) => {
  const r = a(s.business__in), n = a(s.business__notin), o = a(s.groups), c = o ?? void 0, i = o?.map(Number), t = s.org_id ?? (s.business_org_id ? Number(s.business_org_id) : void 0), u = s.city ?? void 0, d = s.query ?? void 0, y = {
    groupIds: i,
    searchBusiness: s.query ?? void 0,
    searchCity: s.city ?? void 0,
    searchOrg: t
  }, g = h(y, n, e);
  return {
    selectedBusinessIds: r,
    unselectedBusinessIds: n,
    selectedGroupIds: c,
    selection: {
      ...y,
      type: g
    },
    searchCity: u,
    searchOrg: t,
    searchBusiness: d
  };
}, v = (s) => {
  const {
    groups: e,
    org_id: r
  } = s, n = a(e);
  return {
    searchOrg: r ?? void 0,
    selectedGroupIds: n
  };
}, S = (s, e) => {
  const {
    searchOrg: r,
    selectedGroupIds: n = []
  } = e ?? {}, o = n ? n.join(",") : "";
  return {
    ...s,
    org_id: r,
    groups: o
  };
};
export {
  B as computePersistentFilterKeysOnReset,
  F as convertFiltersToPreFilters,
  v as convertFiltersToPreFiltersGroups,
  I as convertPreFiltersToFilters,
  S as convertPreFiltersToFiltersGroups
};
